export default __webpack_public_path__ + "static/media/email.f62e026a.svg";